import layoutHeaderAside from '@/layout'

import d_demo from './modules/digital/demo'
import d_dashboard from './modules/digital/dashboard'
import d_digitalExhibitionHall from './modules/digital/digitalExhibitionHall'
import d_personal from './modules/digital/personal'
import d_resourceManagement from './modules/digital/resourceManagement'
import d_projectManager from './modules/digital/projectManager'
import d_dataAnalysis from './modules/digital/dataAnalysis'
import d_customerManage from './modules/digital/customerManage'
import d_master from './modules/digital/master'
import d_expo from './modules/digital/expo'
// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: '/',
        alias: '/digital',
        name: 'index',
        meta: {
          auth: true,
          funcID: 'T00',
          PID: 'T00',
          head: true,
          title: '首页'
        },
        component: _import('digital')
      },
      {
        path: '/403',
        name: '403',
        meta:{
          title: '无权限访问'
        },
        component: _import('system/403')
      },
    ]
  },
  d_demo,
  d_dashboard,
  d_digitalExhibitionHall,
  d_personal,
  d_resourceManagement,
  d_projectManager,
  d_dataAnalysis,
  d_customerManage,
  d_master,
  d_expo
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    meta: {
      funcID: 'LOGIN'
    },
    component: _import('system/login')
  },
  {
    path: '/opview/scm/:code',
    name: `opview-scm-info`,
    meta: {
      auth: false,
      title: '供应商详情'
    },
    component: _import('digital/h5View/scm')
  },
  {
    path: '/opview/fabricrequest/:fabricRequestCode',
    name: `opview-fabricrequest-info`,
    meta: {
      auth: false,
      title: '面料申请单'
    },
    component: _import('digital/h5View/fabricrequest')
  },
  {
    path: '/opview/fabricstockout/:fabricStockOutCode',
    name: `opview-fabricstockout-info`,
    meta: {
      auth: false,
      title: '面料领用单'
    },
    component: _import('digital/h5View/fabricstockout')
  },
  {
    path: '/opview/visit/:code',
    name: `opview-visit-info`,
    meta: {
      auth: false,
      title: '拜访记录详情'
    },
    component: _import('digital/h5View/visit')
  },
  {
    path: '/opview/customer/:custCode',
    name: `opview-customer-info`,
    meta: {
      auth: false,
      title: '客户信息详情'
    },
    component: _import('digital/h5View/customer')
  },
  {
    path: '/opview/myTravel/:userTripRequestCode',
    name: `opview-myTravel-info`,
    meta: {
      auth: false,
      title: '出差申请详情'
    },
    component: _import('digital/h5View/myTravel')
  },
  {
    path: '/opview/myTravelReimbursement/:tripReimbursementCode',
    name: `opview-myTravelReimbursement-info`,
    meta: {
      auth: false,
      title: '出差费用报销详情'
    },
    component: _import('digital/h5View/myTravelReimbursement')
  },
  {
    path: '/opview/myPaymentRequest/:code',
    name: `opview-myPaymentRequest`,
    meta: {
      auth: false,
      title: '日常请款单详情',
    },
    component: _import('digital/h5View/myPaymentRequest'),
  },
  {
    path: '/opview/myReimbursement/:code',
    name: `opview-myReimbursement`,
    meta: {
      auth: false,
      title: '日常报销单详情',
    },
    component: _import('digital/h5View/myReimbursement'),
  },
  {
    path: '/opview/myLoanRequest/:code',
    name: `opview-myLoanRequest`,
    meta: {
      auth: false,
      title: '借款申请单详情',
    },
    component: _import('digital/h5View/myLoanRequest'),
  },
  {
    path: '/opview/fabric/expense/:code',
    name: `opview-fabricExpenseRequest`,
    meta: {
      auth: false,
      title: '面料开发费用详情',
    },
    component: _import('digital/h5View/fabricexpense'),
  },
  {
    path: '/opview/myBizContactForm/:code',
    name: `opview-myBizContactForm`,
    meta: {
      auth: false,
      title: '合祥财务业务联络单详情',
    },
    component: _import('digital/h5View/myBizContactForm'),
  },
  {
    path: '/opview/userMaterialAbnormal/:code',
    name: `opview-userMaterialAbnormal`,
    meta: {
      auth: false,
      title: '合祥物料异常联络单详情',
    },
    component: _import('digital/h5View/userMaterialAbnormal'),
  },
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut
  // ...errorPage
]
